import React, { Component } from 'react'
import { withRouter } from 'react-router'
import AddTagsForm from './AddTagsForm'
import LoadingBars from '../../../Templates/LoadingBars'
import CircularProgress from '@material-ui/core/CircularProgress';

import {fetchAllAttachmentByType} from '../../../../util/attachment_util'
import { fileId, fileKey, fileName } from '../../../../util/file_url'
import { generateAIWorkInstructionCall } from '../../../../util/wi_util'
import { Button } from '@material-ui/core'
import { hasSpecialChar } from '../../../Templates/functions'

class NewWorkInstructionForm extends Component {
  constructor(props) {
    super()
    this.state = {
        workInstructionTitle: '',
        wi: undefined,
        isTrimEnabled: false,
        pdfSelections:[],
        AIPrompt: "",
        AIGenerating:false
    }
  }

  checkKey = (e) => {
    if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
    e.preventDefault()
      var newNameInput = document.getElementById("work-instruction-name");
      newNameInput.removeEventListener("keydown", this.checkKey)
      this.createWorkInstruction(false,null,null)
    }
  }

  componentDidMount = () => {
    this.props.fetchAllTags()
    console.log(process.env.REACT_APP_AI_WI == "true")
    console.log(process.env)
    var newNameInput = document.getElementById("work-instruction-name");
    newNameInput.addEventListener("keydown", this.checkKey);
    fetchAllAttachmentByType("pdf").then(atts=>{
      let options = [];
      for(let i = 0; i< atts.data.length;i++){
        let option = <option value={fileKey(atts.data[i])}>                
                        {atts.data[i].path}
                     </option>
        options.push(option)
      }
      this.setState({pdfSelections:options})
    })
  }

  componentDidUpdate = (prevProps) => {
    if (this.state.wip_id && this.props.workInstructions[this.state.wip_id]) {
      this.props.submitForm(`/dashboard/work instructions parent/${this.state.wip_id + "~&~" + this.state.workInstructionTitle}?pdf=${this.props.workInstructions[this.state.wip_id].is_PDFViewer}`)
    }
  }

  componentWillUnmount = () => {
    this.props.clearFormErrors()
  }

  update(field) {

      return event => {
         let hasSC = hasSpecialChar(event.currentTarget.value)
    // if(event.currentTarget.value.includes("&") || event.currentTarget.value.includes("~") || event.currentTarget.value.includes("|") || event.currentTarget.value.includes("\\") || event.currentTarget.value.includes("/") || event.currentTarget.value.includes("*") || event.currentTarget.value.includes("?") || event.currentTarget.value.includes(":") || event.currentTarget.value.includes("#")){
    //   hasSpecialChar = true
    // }   
        this.setState({
          [field]: event.currentTarget.value,
          hasSpecialChar: hasSC
      }, this.props.errors.length ? this.props.clearFormErrors : null)};
  }

  // For a PDF work instruction, path is the PDF's key, "<attachment id>/<name>".
  createWorkInstruction = (isPDFWip, path, fileExtension) => {
    if (this.state.workInstructionTitle.trim().length == 0 || this.state.hasSpecialChar){
      console.log("Invalid")
    }
    else{
      let workInstructionPayload = {
          isPDFViewer: isPDFWip,
          pdfPath: path,
          title: this.state.workInstructionTitle,
          tags: [],
          release: false,
          steps: [{
              title: "",
              content: "",
              attachments: [],
              defaultAttachment: "",
              timeEstimation: { days: 0, hours: 0, minutes: 0 },
              children: []
          }],
          info_page: {},
          publication_page: { createdBy: this.props.author }
      };

    if (isPDFWip && path && fileExtension) {
        workInstructionPayload.steps[0].attachments.push({
            _id: fileId(path),
            fileExtension: fileExtension,
            path: fileName(path),
            cameraData: "",
            background_color: "",
            annotations: []
        });
    }

    this.props.createWorkInstruction(workInstructionPayload,path, isPDFWip)
        .then((res) => {
            if (res) {
              let payload = {
                wip_id: res.workInstruction._id,
                newTagNames: [],
                selectedTagIds: []
              }
                this.setState({ assigningTags: false, wi: res.workInstruction},()=>{this.assignTags(payload)});
            } else {
                return;
            }
        });
      }
  };

  assignTags = (payload) => {
        this.props.assignTags(payload).then(
          this.setState({
            wip_id: payload.wip_id
          })
        )
  }

  renderErrors = (error) => {
    if (error.includes("E11000")){
      error = "That Title Has Already Been Used"
    }
      return (
        <ul className="flex-columncentered shake-on-error" id="form-errors">
          <li>{error}</li>
        </ul>
      );
  }

  toggleBox = () => {
    this.setState(prevState => ({
      isTrimEnabled: !prevState.isTrimEnabled
    }))
  }

  uploadPDF = () => {
      let input = document.getElementById("importedPDF")
      input.click()
  }

  uploadPDFAny = () => {
    let input = document.getElementById("importedPDFAny")
    input.click()
  }

  updateProgress = (progressEvent) => {
      this.setState({
        loaded: (progressEvent.loaded / progressEvent.total)
        // loaded: (progressEvent.loaded / progressEvent.total * 100)
      })
  }

  convertPDF =(e) => {
      let viewWindow = document.getElementById('dashboard-container')
      let fileType = document.getElementById('select-file-type').value

      viewWindow.classList.add("wait");
        const pdf = e.target.files[0]
        const fd = new FormData();
        const path = pdf.name
        const isTrimEnabled = this.state.isTrimEnabled
        let regex = new RegExp(/.(pdf|PDF)$/)
        let fileExtension = path.match(regex)[0].slice(1)
        if (fileExtension) {
          fd.append("file_name", pdf)
          fd.append("isTrimEnabled", isTrimEnabled)
          fd.append("fileType", fileType)
          setTimeout(() => {
            viewWindow.classList.remove("wait");
          }, 5000);
          Promise.all([this.props.convertPDF(fd, this.updateProgress)]).then(([workInstruction]) => {
            this.setState({
              wip_id: workInstruction._id,
              loading: 0
            })
          }).catch(err => {
            viewWindow.classList.remove("wait")
            this.setState({
              loading: 0
            }, () => window.alert(`There was an error converting that file: Error: ${err}`))
          })
        } else {
          viewWindow.classList.remove("wait")
          return window.alert("You are attempting to upload a file other than a PDF. Supported attachment extensions are .pdf or .PDF")
        }
  }

  selectPDF=()=>{
    let select = document.getElementById("pdfSelectionElement")
    this.setState({workInstructionTitle: fileName(select.value) },()=>this.createWorkInstruction(true,select.value,"pdf"))
   
  }

  uploadPDF =(e) => {
    let viewWindow = document.getElementById('dashboard-container')
    let fileType = document.getElementById('select-file-type').value

    viewWindow.classList.add("wait");
      const pdf = e.target.files[0]
      const fd = new FormData();
      const path = pdf.name
      const isTrimEnabled = this.state.isTrimEnabled
      let regex = new RegExp(/.(pdf|PDF)$/)
      let fileExtension = path.match(regex)[0].slice(1)
      if (fileExtension) {
        fd.append("file_name", pdf)
        fd.append("isTrimEnabled", isTrimEnabled)
        fd.append("fileType", fileType)
        setTimeout(() => {
          viewWindow.classList.remove("wait");
        }, 5000);
        Promise.all([this.props.uploadPDF(fd, this.updateProgress)]).then(([workInstruction]) => {
          this.setState({
            wip_id: workInstruction._id,
            loading: 0
          })
        }).catch(err => {
          viewWindow.classList.remove("wait")
          this.setState({
            loading: 0
          }, () => window.alert(`There was an error converting that file: Error: ${err}`))
        })
      } else {
        viewWindow.classList.remove("wait")
        return window.alert("You are attempting to upload a file other than a PDF. Supported attachment extensions are .pdf or .PDF")
      }
  }

  generateAIWorkInstruction = () => {
   this.setState({AIGenerating :true},()=>{
    generateAIWorkInstructionCall(this.state.AIPrompt).then((res) => {
      const workInstruction = this.convertToWorkInstruction(res.data);
      const timeElapsed = Date.now();
      const today = new Date(timeElapsed);
      const title = `${this.state.AIPrompt}_${today.toISOString()}`
      workInstruction.title = title
      this.props.createWorkInstruction(workInstruction,null, true)
      .then((res) => {
          if (res) {
            let payload = {
              wip_id: res.workInstruction._id,
              newTagNames: [],
              selectedTagIds: []
            }
              this.setState({ assigningTags: false, wi: res.workInstruction, workInstructionTitle: res.workInstruction.title},()=>{this.assignTags(payload)});
              //this.setState({workInstructionTitle:title, assigningTags: true, wi: res.workInstruction });
          } else {
              return;
          }
      });
      
   }).catch((err) => {
     console.log(err)
     this.setState({AIGenerating :true})
    })
   })

  }

   convertToWorkInstruction(data) {
    const steps = Object.keys(data.instruction.steps).map((key, index) => {
        return {
            title: `Step ${index + 1}`,
            content: data.instruction.steps[key],
            attachments: [],
            defaultAttachment: "",
            timeEstimation: { days: 0, hours: 0, minutes: 0 },
            children: []
        };
    });

    const workInstruction = {
        title: this.state.AIPrompt + Date.now.toString(),
        isPDFViewer: false,
        pdfPath: "",
        tags: [],
        release: false,
        steps: steps,
        info_page: {},
        publication_page: { createdBy: this.props.author }
    };

    return workInstruction;
}


  uploadMediaFile = (e) => {
    e.preventDefault()
    let viewWindow = document.getElementById('dashboard-container')
    viewWindow.classList.add("wait");
  
        const attachment = e.target.files[0]
        let fd = new FormData();
        let path = attachment.name

        // --- Start Added Validation ---
        const specialChars = /[&~|\\/*?:#]/; // Regex for forbidden characters
        if (specialChars.test(path)) {
            viewWindow.classList.remove("wait");
            window.alert("Filename cannot contain special characters: &, ~, |, \\, /, *, ?, :, #");
            // Clear the file input in case the user tries to submit the same file again
            e.target.value = null; 
            return; 
        }
        // --- End Added Validation ---

        let regex = new RegExp(/.(pdf|PDF)$/)
        let match = path.match(regex)
        let fileExtension = match ? match[0].slice(1) : null
        if (fileExtension && fileExtension.includes(".")){
            fileExtension = fileExtension.slice(1)
        }

        if(fileExtension) {
            fd.append('attachment', attachment)
            fd.append('path', path)
            setTimeout(() => {
                viewWindow.classList.remove("wait");
            }, 5000);
            Promise.all([this.props.uploadPDF(fd,true)]).then(([res]) => {
                let payload = { _id: res._id, fileExtension, path }
                this.setState({workInstructionTitle: path },()=>this.createWorkInstruction(true,fileKey(res),fileExtension))
                
              //  this.attachFile(payload)
            }).catch(err => {
                window.alert("An Error occured in uploading that file.", err)
                viewWindow.classList.remove("wait")
            })
        } else {
            viewWindow.classList.remove("wait")
            return window.alert("You are attempting to upload an attachment type that is not supported. Supported attachment extensions are .png, .tiff, .jpg, .jpeg, .mp4, .mov, .mp3, and .pdf. If you are attempting to upload a model, please use the Model Uploader.")
        }
    
  }

    render() {
      return (
        <form onSubmit={null}>
          <div id='new-work-instruction-form'>
          {this.state.assigningTags ?
          <AddTagsForm tags={this.props.tags} wi={this.state.wi} assignTags={this.assignTags}/>
              : 
                <div id="new-work-instruction-options" className="flex">



                  <div id="option-new" className="flex-column-centered wi_Create_Option" style={{justifyContent:"space-between"}}>
                        <h3 style={{marginBottom: '1em'}}>Create Work Instruction</h3> 
                        <div className='input-box' style={{ width: "95%" }}>
                            <div id="work-instruction-name-container" className="nameContainer">
                                <input id="work-instruction-name"
                                  type="text"
                                  value={this.state.workInstructionTitle}
                                  onChange={this.update('workInstructionTitle')}
                                  placeholder="Title Your Work Instruction"
                                />
                            </div>
                        </div>
                        {this.state.hasSpecialChar ? <div >
                          <p className="error-message" style={{display: this.state.hasSpecialChar ? "block" : "none"}}>Title cannot contain special characters (&, ~, |, \\, /, *, ?, :)</p>
                        </div> : null}
                        <div>
                          <div className="button clickable" disabled={this.state.workInstructionTitle.trim().length == 0 || this.state.hasSpecialChar } onClick={()=>this.createWorkInstruction(false)}>
                            <p>Create</p>
                          </div>
                          {this.props.errors.length > 0 ? this.renderErrors(this.props.errors) : null}
                        </div>
                  </div>  
                  {/* /////////////////////////////////////////////////////////////////////// */}  
                    { String(process.env.REACT_APP_AI_WI).toLowerCase() === "true" ? <div id="AICreated" className="flex-column-centered wi_Create_Option" style={{justifyContent:"space-between"}}>
                        <h3 style={{marginBottom: '1em'}}>Generate Work Instruction using AI</h3>                            
                        <div className='input-box' style={{ width: "94%", marginLeft:"6%"}}>
                          <div id="AI-name-container" className="nameContainer">
                            <input id="AIPrompt"
                              type="text"
                              value={this.state.AIPrompt}
                              onChange={(event)=>{this.setState({AIPrompt: event.target.value})}}
                              placeholder="Ai Prompt"
                            />
                          </div>
                        </div>
                        <div className="button clickable" disabled={this.state.AIPrompt.trim().length == 0 } onClick={()=>{this.generateAIWorkInstruction()}}>
                        
                           {this.state.AIGenerating ? <CircularProgress  style={{height:"15px",width:"15px",color:"white"}}/> : <p>Generate</p>} 
                       
                        </div>
                  </div>  : null}

                  {/* /////////////////////////////////////////////////////////////////////// */}  
                  <div id="pdfHolder" className="flex-column-centered " style={{justifyContent:"space-between"}}>
                    <div id="work-instruction-name-container">
                      <label>Enhance existing PDF Work Instruction</label>
                    </div>
                    <div className="flex" style={{height:"55%"}}>                  
                      <div className="max-size flex-column" style={{alignItems: "center", justifyContent: "space-between", flexDirection:"row" }}>                   
                        <div className="flex-column-centered">
                          <div className="flex-centered-centered">  
                            <div className="button clickable" onClick={this.uploadPDFAny}>
                              <p>Upload</p>
                            </div>
                            <div className="hidden">
                              <input type="file" 
                                name="importedPDFAny" 
                                id="importedPDFAny" 
                                onChange={this.uploadMediaFile} />
                            </div>
                          </div>                    
                        </div>
                      </div>
                    </div>
                  </div>  
        
                
                  {/* /////////////////////////////////////////////////////////////////////// */}
                
              </div>
            }
        </div>
      </form>
    )
  }
}
export default withRouter(NewWorkInstructionForm)